import { useIntl } from 'react-intl'
import ListingDrawerEmptyState from '../ListingDrawerEmptyState'
import { formatPlacePhrase } from '@luxuryescapes/lib-location-grammar'

interface Props {
  placeName: string
  searchUrl: string
}

function ExperienceListingEmptyState({
  placeName,
  searchUrl,
}: Props) {
  const intl = useIntl()

  const noExperiencesAlt = intl.formatMessage({
    id: 'cESZwFadmYPnv5-e1gtx',
    defaultMessage: 'No experiences available',
    description: 'Alt text for the illustration shown when no experiences are available for the selected stop.',
  })

  const noExperiencesHeading = intl.formatMessage({
    id: 'CcL5WLlqTXvgVMEEB7fq',
    defaultMessage: 'No experiences available in this area',
    description: 'Heading shown in the experience drawer when the search returns zero experiences for the selected location.',
  })

  const noExperiencesMessage = intl.formatMessage({
    id: 'I57EkcPMU_ooonrBbmuu',
    defaultMessage: 'We don’t have any Luxury Escapes deals in {placeName} right now.',
    description: 'Body copy shown in the experience drawer empty state when there are no Luxury Escapes deals for the selected place.',
  }, { placeName: formatPlacePhrase({ location: { name: placeName }, language: intl.locale, intent: 'location' }) })

  const viewMoreLabel = intl.formatMessage({
    id: 'CSHDrN76wU1m1aZb4s0_',
    defaultMessage: 'View more on Luxury Escapes',
    description: 'Button label in the experience drawer empty state linking to more Luxury Escapes deals for that destination.',
  })

  return (
    <ListingDrawerEmptyState
      imageAlt={noExperiencesAlt}
      heading={noExperiencesHeading}
      body={noExperiencesMessage}
      ctaLabel={viewMoreLabel}
      searchUrl={searchUrl}
      isBodyCentered
    />
  )
}

export default ExperienceListingEmptyState
